import "slick-carousel/slick/slick.css";
import "@/assets/lib/slick-theme.css";
// @ts-ignore
import $ from "jquery";
import "slick-carousel";
import setupSlickArrowMobileFeedback from "./slick-arrow-mobile-feedback";

export default function SlickCarousel() {
  const slickElement = document.querySelectorAll<HTMLDivElement>(".js-slick-carousel");

  if (slickElement && slickElement.length > 0) {
    slickElement.forEach((el: HTMLDivElement) => {
      if (el) {
        const desktopSlides = el.getAttribute("data-desktop-slides");
        const tabletSlides = el.getAttribute("data-tablet-slides");
        const mobileSlides = el.getAttribute("data-mobile-slides");
        const carouselEl = el.querySelector<HTMLDivElement>(".js-slick");
        const slides = el.querySelectorAll<HTMLDivElement>(".js-item");
        const nextBtn = el.querySelector<HTMLButtonElement>(".slick-btn-next");
        const prevBtn = el.querySelector<HTMLButtonElement>(".slick-btn-prev");
        const delay = el.getAttribute("data-delay");
        const isInfinite = el.getAttribute("data-infinite")?.toLowerCase() === "true" ? true : false;
        const shouldAutoplay = el.getAttribute("data-autoplay")?.toLowerCase() === "true" ? true : false;
        const isFadeAnimation = el.getAttribute("data-fade")?.toLowerCase() === "true" ? true : false;
        const showDotNav = el.getAttribute("data-dots")?.toLowerCase() === "true" ? true : false;

        const debounce = (func: () => void, delay: number) => {
          let timeout: any;
          return function () {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
              func();
            }, delay);
          };
        };

        const handleCustomDotOverrides = () => {
          if (showDotNav) {
            const slickDots = el?.querySelector<HTMLElement>(".slick-dots");

            if (slickDots) {
              slickDots.style.setProperty("padding-top", "0px", "important");
              slickDots.style.setProperty("display", "flex", "important");
            }
          }
        };

        const handleSlick = () => {
          $(carouselEl).slick({
            infinite: isInfinite,
            autoplay: shouldAutoplay,
            autoplaySpeed: delay ? parseInt(delay) * 1000 : 0,
            slidesToShow: desktopSlides ? parseInt(desktopSlides) : 5,
            adaptiveHeight: true,
            fade: isFadeAnimation,
            arrows: true,
            prevArrow: prevBtn,
            nextArrow: nextBtn,
            dots: showDotNav,
            appendDots: $(el).find(".js-custom-dots"),
            responsive: [
              {
                breakpoint: 1216,
                settings: {
                  slidesToShow: tabletSlides ? parseInt(tabletSlides) : 3,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: mobileSlides ? parseInt(mobileSlides) : 1,
                },
              },
            ],
          });

          setupSlickArrowMobileFeedback(carouselEl, prevBtn, nextBtn);

          if (carouselEl) {
            carouselEl.style.opacity = "1";
          }

          handleCustomDotOverrides();
        };

        if (carouselEl && slides && slides.length > 1) {
          handleSlick();
          window.addEventListener("resize", debounce(handleCustomDotOverrides, 100));
        }
      }
    });
  }
}
